import { z } from "zod";
import { PatientProfileSchema } from "./patient-profile.js";
import { IdempotencyKeySchema, IdSchema } from "./primitives.js";
/** A workforce physician, identified by membership user ID rather than display text. */
export const PhysicianSummarySchema = z
    .object({
    userId: IdSchema,
    displayName: z.string().min(1).max(160),
    active: z.boolean(),
})
    .passthrough();
export const ClinicPhysiciansResponseSchema = z
    .object({
    siteId: IdSchema,
    physicians: z.array(PhysicianSummarySchema),
})
    .passthrough();
/** Durable usual-physician assignment. Version 0 means no assignment has ever been recorded. */
export const PatientPhysicianRosterSchema = z
    .object({
    version: z.number().int().nonnegative(),
    physician: PhysicianSummarySchema.nullable(),
})
    .passthrough();
export const UpdatePatientPhysicianRequestSchema = z
    .object({
    siteId: IdSchema,
    expectedVersion: z.number().int().nonnegative(),
    physicianUserId: IdSchema.nullable(),
    idempotencyKey: IdempotencyKeySchema,
})
    .strict();
export const PatientPhysicianUpdateReceiptSchema = z
    .object({
    patientId: IdSchema,
    siteId: IdSchema,
    roster: PatientPhysicianRosterSchema,
})
    .passthrough();
/** Administrative roster metadata extends the profile response, not the evaluated clinical contract. */
export const PatientRosterProfileSchema = PatientProfileSchema.extend({
    roster: PatientPhysicianRosterSchema.optional(),
});
//# sourceMappingURL=patient-physician.js.map